<script>
  import Crown from '@/Elements/Crown.svelte';
  import Navbar from '@/Composites/Navs/Bar.svelte';
  import Container from '@/Elements/Containers/FullCentred.svelte';
  import Title from '@/Elements/Signals/Title.svelte';
  import Lead from '@/Elements/Signals/Text/Base.svelte';
  import Overlay from '@/Elements/Display/Overlay.svelte';
  import Image from '@/Elements/Display/Image.svelte';
  
  export let crown;
  export let navs;
  export let feature;

  let title = feature.title;
  let text = feature.text;
  let img = feature.img;

  function scrollUp(event) {
    window.scrollTo(0,0);
  }

</script>

<style></style>

<section onload={scrollUp()} id="feature">
  <div class="absolute z-50 w-full">
    <Container>
      <div class="flex items-center justify-between pt-4 md:pt-8 lg:pt-10 px-var">
        <Crown {crown} />
        <Navbar {navs} />
      </div>
    </Container>
  </div>
  <Overlay>
    <Container>
      <div class="h-full flex flex-col justify-end items-start space-y-3 px-var py-32 md:py-6">
        <Title>{title}</Title>
        <Lead>{text}</Lead>
      </div>
    </Container>
  </Overlay>
  <Image {img} />

</section>